import {Tour, TourCreateDTO, TourUpdateDTO} from "../models/tour";
import {MembershipsInTour} from "../models/membership";
import {authFetch} from "../auth/authFetch";

const API_BASE = "/api/tours";

/**
 * Holt alle Touren.
 */
export async function getAllTours(): Promise<Tour[]> {
    const res = await authFetch(API_BASE);
    if (!res.ok) {
        throw new Error("Failed to fetch tours");
    }
    return res.json();
}

/**
 * Holt alle Touren nach tourCode oder destination.
 */
export async function getAllToursByTourCodeOrDestination(input: string): Promise<Tour[]> {
    const res = await authFetch(`${API_BASE}/searchInput/${input}`);
    if (!res.ok) {
        throw new Error("Failed to fetch tours");
    }
    return res.json();
}

/**
 * Holt eine einzelne Tour per ID.
 */
export async function getTourById(id: number): Promise<Tour> {
    const res = await authFetch(`${API_BASE}/id/${id}`);
    if (!res.ok) {
        throw new Error(`Tour with id ${id} not found`);
    }
    return res.json();
}

/**
 * Holt eine einzelne Tour per Tour-Code.
 */
export async function getTourByCode(tourCode: string): Promise<Tour> {
    const res = await authFetch(`${API_BASE}/tourCode/${tourCode}`);
    if (!res.ok) {
        throw new Error(`Tour with code ${tourCode} not found`);
    }
    return res.json();
}

export async function getAccountsInTour(tourId: number): Promise<MembershipsInTour> {
    const res = await authFetch(`${API_BASE}/accountsInTour/${tourId}`);
    if (!res.ok) {
        throw new Error(`Tour with id ${tourId} not found`);
    }
    return res.json();
}

/**
 * Legt eine neue Tour an.
 */
export async function createTour(dto: TourCreateDTO): Promise<Tour> {
    const res = await authFetch(API_BASE, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(dto)
    });

    if (!res.ok) {
        throw new Error("Failed to create tour");
    }

    return res.json();
}

/**
 * Aktualisiert eine bestehende Tour.
 */
export async function updateTour(id: number, dto: TourUpdateDTO): Promise<Tour> {
    const res = await authFetch(`${API_BASE}/${id}`, {
        method: "PATCH",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(dto)
    });

    if (!res.ok) {
        throw new Error(`Failed to update tour with id ${id}`);
    }

    return res.json();
}

/**
 * Löscht eine Tour.
 */
export async function deleteTour(id: number): Promise<void> {
    const res = await authFetch(`${API_BASE}/${id}`, {
        method: "DELETE"
    });

    if (!res.ok) {
        throw new Error(`Failed to delete tour with id ${id}`);
    }
}
